import React from 'react'
import Card from '../shared/card/card'
import root from '../shared/utils'
import {getOrdinalDate} from '../shared/enums/date-parser'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

const OrderStatus = ({ card, noPullDown }) => {
  let taskTypeIcon = getTaskTypeIconParser(card.taskType);
  let midIconRoot = root + '/common/latest/images/consumer/status-icons/';
  let midIcon = midIconRoot + 'CONFIRMED.png';
  let rightIcon = taskTypeIcon.iconsrc;
  let date;

  if(card.workFlowStep === "NEEDS_CONTRACTOR") {
    midIcon = midIconRoot + 'SCHEDULED.png';
    //24hrs * 60min * 60sec * 1000ms -> 86400000 -> 1 day;
    let dayDelta = ( card.mobileTask.interval === "WEEKLY" || card.mobileTask.interval === "ONE_TIME" ? 86400000 : 2 * 86400000 );
    date = getOrdinalDate(card.millisDate - dayDelta) + " - " + getOrdinalDate(card.millisDate + dayDelta);
  } else {
    date = getOrdinalDate(card.millisDate);
  }
  return (
    <Card
      headerTitle={card.header}
      headerLeftIcon={card.date}
      headerMidIcon={midIcon}
      headerRightIcon={rightIcon}
      headerSubtitle={date}
      noPullDown={noPullDown}
      >
      <p dangerouslySetInnerHTML={{ __html: card.content }} />

    </Card>
  )  
}

OrderStatus.propTypes = {
  card: React.PropTypes.object.isRequired,
  noPullDown: React.PropTypes.bool
}

export default OrderStatus



// WEBPACK FOOTER //
// ./src/components/dashboard/order-status-card.jsx